@for (menuItem of menuItems(); track menuItem) {
<!-- Root level -->
@if (menuItem?.subMenu?.length) {
<div>
    <app-static-sub-menu (hideMenu$)="hideMenu()" (click)="categorySelected(menuItem.id, $event)" [collapsed]="menuItem?.id !== selectedCategoryId()" [menuItem]="menuItem" [menuCollapseIcon]="headerData().menuCollapseIcon" [headerLayout]="headerLayout()">
        <!-- Child level -->
        @for (sub_Menu of menuItem?.subMenu; track sub_Menu) {
        @if (sub_Menu?.subMenu?.length) {
        <app-static-sub-menu-child (hideMenu$)="hideMenu()" (click)="subCategorySelected(sub_Menu.id, $event)" [collapsed]="sub_Menu?.id !== selectedSubCategoryId()" [menuItem]="sub_Menu" [menuCollapseIcon]="headerData().menuCollapseIcon" [headerLayout]="headerLayout()">
            <!-- Default ul/li for all layouts except layout-12 -->
            @if (!isLayout12()) {
            <ul class="link-menu-list-inner">
                @for (child_category of sub_Menu?.subMenu; track child_category) {
                <li>
                    @if (child_category?.text) {
                    <a (click)="hideMenu$.emit(true)" [target]="menuItem.target" [attr.data-click_action_value]="menuItem['data-click_action_value']" [attr.data-click_action_choice]="menuItem['data-click_action_choice']" class="mobile-child-sub-menu">{{ child_category?.text }}</a>
                    }
                </li>
                }
            </ul>
            }

            <!-- Layout-12 specific ul/li - showing child category images -->
            @if (isLayout12()) {
            <ul class="link-menu-sub-child layout-12-sub-category-item">
                @for (child_category of sub_Menu?.subMenu; track child_category) {
                <li class="link-menu-sub-child layout-12-sub-category-item menu-item-main-container">
                    <div class="layout-12-sub-wrapper menu-item-image-anchor-container">
                        <div class="combine-wrapper">
                            <div class="layout-12-sub-icon menu-item-image-container">
                                <img [id]="child_category.id" class="layout-12-sub-thumbnail menu-item-category-image" [src]="child_category.categoryImage || IMAGE_URLS.productEmptyState" [attr.data-click_action_value]="menuItem['data-click_action_value']" [attr.data-click_action_choice]="menuItem['data-click_action_choice']" />
                            </div>
                            @if (child_category?.text) {
                            <a (click)="hideMenu$.emit(true)" [target]="menuItem.target" [attr.data-click_action_value]="menuItem['data-click_action_value']" [attr.data-click_action_choice]="menuItem['data-click_action_choice']" class="mobile-child-sub-menu layout-12-child-link mobile-category-menu">{{ child_category?.text }}</a>
                            }
                        </div>
                    </div>
                </li>
                }
            </ul>
            }
        </app-static-sub-menu-child>
        } @else {
        <!-- Default ul/li for all layouts except layout-12 -->
        @if (!isLayout12()) {
        <ul class="link-menu-sub-child">
            <li>
                <a (click)="hideMenu$.emit(true)" [target]="sub_Menu.target" [attr.data-click_action_value]="sub_Menu['data-click_action_value']" [attr.data-click_action_choice]="sub_Menu['data-click_action_choice']" class="mobile-sub-menu">{{ sub_Menu?.text }}</a>
            </li>
        </ul>
        }

        <!-- Layout-12 specific ul/li - showing sub-category images -->
        @if (isLayout12()) {
        <ul class="link-menu-sub-child layout-12-sub-category">
            <li class="layout-12-sub-category-item menu-item-main-container">
                <div class="layout-12-sub-wrapper menu-item-image-anchor-container">
                    <div class="combine-wrapper">
                        <div class="layout-12-sub-icon menu-item-image-container">
                            <img [id]="sub_Menu.id" class="layout-12-sub-thumbnail menu-item-category-image" [src]="sub_Menu.categoryImage || IMAGE_URLS.productEmptyState" [attr.data-click_action_value]="sub_Menu['data-click_action_value']" [attr.data-click_action_choice]="sub_Menu['data-click_action_choice']" />
                        </div>
                        <a (click)="hideMenu$.emit(true)" [target]="sub_Menu.target" [attr.data-click_action_value]="sub_Menu['data-click_action_value']" [attr.data-click_action_choice]="sub_Menu['data-click_action_choice']" class="mobile-sub-menu mobile-category-menu layout-12-sub-link">{{ sub_Menu?.text }}</a>
                    </div>
                </div>
            </li>
        </ul>
        }
        }
        }
    </app-static-sub-menu>
</div>
} @else {
@if (menuItem.text !== 'Category Header' && !isLayout12()) {
<ul class="non-collapse-list">
    <li>
        <a (click)="hideMenu$.emit(true)" [target]="menuItem.target" [attr.data-click_action_value]="menuItem['data-click_action_value']" [attr.data-click_action_choice]="menuItem['data-click_action_choice']" class="mobile-category-menu">{{ menuItem?.text }}</a>
    </li>
</ul>
}
<!-- Layout-12 specific ul/li - keeping same structure but with different styling -->
@if (menuItem.text !== 'Category Header' && isLayout12()) {
<ul class="non-collapse-list layout-12-dynamic-single link-menu-sub-child">
    <li class="layout-12-dynamic-single-item layout-12-sub-category-item menu-item-main-container">
        <div class="layout-12-single-wrapper layout-12-sub-wrapper menu-item-image-anchor-container">
            <div class="combine-wrapper">
                <div class="layout-12-single-icon layout-12-sub-icon menu-item-image-container">
                    <img [id]="menuItem.id" class="layout-12-single-thumbnail category-image layout-12-sub-thumbnail menu-item-category-image" [src]="menuItem.categoryImage || IMAGE_URLS.productEmptyState" />
                </div>
                <a class="mobile-category-menu layout-12-single-link mobile-category-menu" [target]="menuItem.target" [attr.data-click_action_value]="menuItem['data-click_action_value']" [attr.data-click_action_choice]="menuItem['data-click_action_choice']" [id]="menuItem.id">{{ menuItem?.text }}</a>
            </div>
        </div>
    </li>
</ul>
}
}
}